import { render, staticRenderFns } from "./Phq15.vue?vue&type=template&id=1327b663&scoped=true&"
import script from "./Phq15.vue?vue&type=script&lang=ts&"
export * from "./Phq15.vue?vue&type=script&lang=ts&"
import style0 from "./Phq15.vue?vue&type=style&index=0&id=1327b663&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1327b663",
  null
  
)

export default component.exports